"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgOutlook(props, svgRef) {
  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 16",
    ref: svgRef
  }, props), {}, {
    children: [(0, _jsxRuntime.jsxs)("defs", {
      children: [(0, _jsxRuntime.jsxs)("linearGradient", {
        id: "outlook_svg__a",
        x1: "50%",
        x2: "50%",
        y1: "0%",
        y2: "100%",
        children: [(0, _jsxRuntime.jsx)("stop", {
          offset: "0%",
          stopColor: "#35B8F1"
        }), (0, _jsxRuntime.jsx)("stop", {
          offset: "100%",
          stopColor: "#28A8EA"
        })]
      }), (0, _jsxRuntime.jsxs)("linearGradient", {
        id: "outlook_svg__b",
        x1: "17.372%",
        x2: "82.628%",
        y1: "-6.51%",
        y2: "106.51%",
        children: [(0, _jsxRuntime.jsx)("stop", {
          offset: "0%",
          stopColor: "#1784D9"
        }), (0, _jsxRuntime.jsx)("stop", {
          offset: "50%",
          stopColor: "#107AD5"
        }), (0, _jsxRuntime.jsx)("stop", {
          offset: "100%",
          stopColor: "#0A63C9"
        })]
      })]
    }), (0, _jsxRuntime.jsxs)("g", {
      fillRule: "nonzero",
      fill: "none",
      children: [(0, _jsxRuntime.jsx)("path", {
        fill: "#0A2767",
        d: "M14.691 7.962a.273.273 0 00-.13-.235h-.001l-.005-.002-4.231-2.505a.568.568 0 00-.634 0L5.46 7.724l-.006.002a.276.276 0 00.007.473l4.23 2.503a.562.562 0 00.634 0l4.23-2.503a.272.272 0 00.135-.238z"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#0364B8",
        d: "M5.954 6.29H8.73v2.544H5.954V6.29zm8.17-2.587V2.54a.528.528 0 00-.515-.539H6.404a.527.527 0 00-.514.54v1.163l4.259 1.136 3.974-1.136z"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#0078D4",
        d: "M5.891 3.703H8.73v2.555H5.891z"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#28A8EA",
        d: "M11.568 3.703H8.73v2.555l2.838 2.555h2.555V6.258z"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#0078D4",
        d: "M8.73 6.258h2.838v2.555H8.73z"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#0364B8",
        d: "M8.73 8.813h2.838v2.555H8.73z"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#14447D",
        d: "M5.954 8.834H8.73v2.313H5.954z"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#0078D4",
        d: "M11.568 8.813h2.555v2.555h-2.555z"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "url(#outlook_svg__a)",
        d: "M12.077 6.184l-.005.003-4.23 2.379c-.019.011-.037.022-.057.032a.59.59 0 01-.23.056l-.23-.135a.524.524 0 01-.057-.032L2.98 6.04l-.14-.078v4.816c.002.32.264.58.586.578h8.206c.004 0 .009-.003.014-.003a.712.712 0 00.199-.041.68.68 0 00.08-.042c.018-.01.051-.034.051-.034a.573.573 0 00.232-.458V5.962c0 .092-.05.177-.13.222z",
        transform: "translate(2.484 2)"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#0A2767",
        d: "M14.464 7.943v.295l-4.423 3.045-4.579-3.241c0-.002-.001-.003-.003-.003l-.42-.252v-.213l.173-.003.366.21.009.003.031.02s4.304 2.455 4.315 2.46l.165.097.045-.017 4.273-2.404.048.003z",
        opacity: 0.5
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#1490DF",
        d: "M14.561 8.184l-.005.003-4.23 2.38c-.019.01-.037.021-.057.03a.587.587 0 01-.52 0c-.02-.009-.039-.02-.057-.03l-4.23-2.38-.005-.003a.256.256 0 01-.134-.222v4.816c.002.32.264.58.585.578h8.198a.582.582 0 00.585-.578V7.962c0 .092-.05.177-.13.222z"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#000",
        d: "M10.387 10.53l-.063.036a.578.578 0 01-.28.092l1.61 1.903 2.807.676a.576.576 0 00.178-.222l-4.252-2.485z",
        opacity: 0.1
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#000",
        d: "M10.674 10.37l-.35.196a.578.578 0 01-.28.092l.754 2.078 3.664.5a.574.574 0 00.23-.458v-.063l-4.018-2.345z",
        opacity: 0.05
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#28A8EA",
        d: "M5.916 13.356h8.189c.126 0 .249-.04.35-.114L9.809 10.52a.392.392 0 01-.056-.033L5.464 8.041h-.002l-.14-.08v4.8c0 .328.265.594.593.595z"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#000",
        d: "M9.297 4.791v6.056a.52.52 0 01-.519.522H5.323V4.555h.568v-.284h2.887a.522.522 0 01.52.52z",
        opacity: 0.1
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#000",
        d: "M9.014 5.075v6.056a.468.468 0 01-.043.198.516.516 0 01-.477.323H5.323V4.555h3.17a.49.49 0 01.237.06.514.514 0 01.283.46z",
        opacity: 0.2
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#000",
        d: "M9.014 5.075v5.488a.524.524 0 01-.52.521H5.323V4.555h3.17a.49.49 0 01.237.06.514.514 0 01.283.46z",
        opacity: 0.2
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#000",
        d: "M8.73 5.075v5.488c0 .287-.233.52-.52.521H5.323V4.555H8.21a.52.52 0 01.52.52z",
        opacity: 0.2
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "url(#outlook_svg__b)",
        d: "M.52 2.555h5.205a.52.52 0 01.52.52V8.28c0 .288-.232.52-.52.52H.52A.519.519 0 010 8.28V3.075a.52.52 0 01.52-.52z",
        transform: "translate(2.484 2)"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#FFF",
        d: "M4.11 6.738c.129-.274.336-.502.595-.657.287-.164.614-.246.944-.237.307-.007.61.071.874.225.25.148.45.366.579.627.14.287.209.604.202.923.007.333-.064.664-.208.965a1.54 1.54 0 01-.596.65c-.276.157-.59.237-.907.23a1.719 1.719 0 01-.894-.227 1.529 1.529 0 01-.585-.629 1.985 1.985 0 01-.205-.911c-.006-.331.063-.66.201-.96zm.634 1.541a.975.975 0 00.334.432.871.871 0 00.523.157.914.914 0 00.557-.162.946.946 0 00.325-.432c.071-.193.106-.397.104-.603a1.834 1.834 0 00-.098-.61.965.965 0 00-.314-.45.855.855 0 00-.553-.17.896.896 0 00-.535.158.993.993 0 00-.34.436c-.155.4-.156.844-.003 1.245z"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#50D9FF",
        d: "M11.568 3.703h2.555v2.555h-2.555z"
      })]
    })]
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlook);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Outlook.js.map